import React from 'react';
import { iconEnJa, IconType } from '../../lib/FL';

import styles from './Icon.module.scss';

const Icon: React.FC<{ icon: IconType }> = ({ icon }) => {
  const iconClass = styles[`icon_${icon}`];
  return (
    <li className={`${styles.icon} ${iconClass}`} key={icon}>
      {iconEnJa[icon]}
    </li>
  );
};

export const Icons: React.FC<{ icons: IconType[] }> = ({ icons }) => {
  if (icons.length === 0) {
    return null;
  }
  return (
    <ul className={styles.icons}>
      {icons.map((icon) => (
        <Icon icon={icon} key={icon} />
      ))}
    </ul>
  );
};
